import React from 'react';
import './Tile.css';
import tenantStorage from '../../utils/tenantStorage';

const Tile = ({
  icon,
  title,
  label, // for compatibility if label is used instead of title
  description,
  onClick,
  disabled = false,
  access_roles = ['RT_NoAccess'], // Default to RT_Admin only
  ...rest
}) => {
  // Check if user has access to this tile
  const userRole = tenantStorage.getItem('userRole') || 'RT_NoAccess';
  const hasAccess = access_roles.includes(userRole);
  
  // If user doesn't have access, don't render the tile
  if (!hasAccess) {
    return null;
  }

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  const handleKeyDown = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onClick) {
        onClick(e);
      }
    }
  };

  return (
    <div 
      className={`rt-tile ${disabled ? 'rt-tile-disabled' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      {...rest}
    >
      <div className="rt-tile-content">
        {icon && (
          <span className="rt-tile-icon" aria-hidden="true">
            {icon}
          </span>
        )}
        <div className="rt-tile-text">
          <div className="rt-tile-title">{title || label}</div>
          {description && <div className="rt-tile-description">{description}</div>}
        </div>
      </div>
    </div>
  );
};

export default Tile;